import { AxiosResponse } from 'axios';
import { api, API_URL } from '@api/config';
import { IBaseQuery, IBookingObj, PaginatedType } from '@types';
import {
    IAtsUsersQuery,
    IBookingFormReq,
    IBookingQuery,
    ICallsQuery,
    IPromouter,
    IReservedTablesQuery,
} from './types';
import { IAtsUserData, ICalls, ITableBooking } from '@entities/booking/types';

const BASE_PATH = 'shops';

export const getBookingReuest = (
    shop_id: number,
    params: IBookingQuery
): Promise<AxiosResponse<PaginatedType<IBookingObj>>> => {
    return api.get<PaginatedType<IBookingObj>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/booking`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const createBookingRequest = (
    shop_id: number,
    data: IBookingFormReq
): Promise<AxiosResponse<IBookingFormReq>> => {
    return api.post<IBookingFormReq>(
        `${API_URL}/${BASE_PATH}/${shop_id}/booking`,
        data
    );
};

export const getPromoutersReuest = (
    shop_id: number,
    params: IBaseQuery
): Promise<AxiosResponse<PaginatedType<IPromouter>>> => {
    return api.get<PaginatedType<IPromouter>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/promo/promouters`,
        {
            params: {
                ...params,
            },
        }
    );
};
export const getCallsRequest = (
    shop_id: number,
    params: ICallsQuery
): Promise<AxiosResponse<PaginatedType<ICalls>>> => {
    return api.get<PaginatedType<ICalls>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/ats/calls`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getAtsUsersRequest = (
    shop_id: number,
    params: IAtsUsersQuery
): Promise<AxiosResponse<IAtsUserData[]>> => {
    return api.get<IAtsUserData[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/ats/users`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getReservedTablesRequest = (
    shop_id: number,
    params: IReservedTablesQuery
): Promise<AxiosResponse<ITableBooking[]>> => {
    return api.get<ITableBooking[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/booking/tables`,
        {
            params: {
                ...params,
            },
        }
    );
};
